<div class="container my-4" *ngIf="userDetail">
  <!-- User Summary -->
  <div class="card shadow-sm mb-4">
    <div class="card-body">
      <h4 class="card-title">User Details</h4>
      <p class="mb-1"><strong>User ID:</strong> {{ userDetail.userId }}</p>
      <p class="mb-1"><strong>Score:</strong> {{ userDetail.score }}%</p>
      <p class="mb-0">
        <strong>Top Role:</strong>
        {{ userDetail.topRole?.name }} ({{ userDetail.topRole?.description }})
      </p>
    </div>
  </div>

  <!-- All Roles Accordion -->
  <div class="accordion" id="rolesAccordion">
    <div
      class="accordion-item"
      *ngFor="let role of userDetail.allRoles; let i = index"
    >
      <h2 class="accordion-header" id="heading{{ i }}">
        <button
          class="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          [attr.data-bs-target]="'#collapse' + i"
          [attr.aria-expanded]="i === 0 ? 'true' : 'false'"
          [attr.aria-controls]="'collapse' + i"
        >
          {{ role.name }} ({{ role.matchLevel }}) - {{ role.scorePercent }}%
        </button>
      </h2>
      <div
        [id]="'collapse' + i"
        class="accordion-collapse collapse"
        [class.show]="i === 0"
        [attr.aria-labelledby]="'heading' + i"
        data-bs-parent="#rolesAccordion"
      >
        <div class="accordion-body">
          <p>
            <strong>Core Matches:</strong> {{ role.coreMatchCount }} |
            <strong>Secondary Matches:</strong> {{ role.secondaryCount }} |
            <strong>Optional Matches:</strong> {{ role.optionalCount }}
          </p>
          <p>
            <strong>Total Score:</strong> {{ role.totalScore }} /
            {{ role.maxPossibleScore }}
          </p>

          <!-- Matched Categories -->
          <h6 class="mt-3">Matched Categories</h6>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Category ID</th>
                <th>Priority</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cat of role.matchedCategories">
                <td>{{ cat.categoryId }}</td>
                <td>{{ cat.priority }}</td>
              </tr>
              <tr *ngIf="!role.matchedCategories?.length">
                <td colspan="2" class="text-muted text-center">
                  No matches
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Unmatched Categories -->
          <h6 class="mt-3">Unmatched Categories</h6>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Category ID</th>
                <th>Priority</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cat of role.unmatchedCategories">
                <td>{{ cat.categoryId }}</td>
                <td>{{ cat.priority }}</td>
              </tr>
              <tr *ngIf="!role.unmatchedCategories?.length">
                <td colspan="2" class="text-muted text-center">
                  All matched
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <button class="btn btn-secondary mb-3" (click)="goBack()">
  <i class="bi bi-arrow-left"></i> Back
</button>

</div>
